import { Component } from '@angular/core';

@Component({
  selector: 'app-payment-panel-stripe-bancontact',
  templateUrl: './payment-panel-stripe-bancontact.component.html',
})
export class PaymentPanelStripeBancontactComponent {}
